/** Grymwyrd – Textes français pour la fonctionnalité Jouer / VTT. */
export const playFr = {
  // CampaignList
  'play.campaigns.heading': 'Mes Campagnes',
  'play.campaigns.signIn': 'Se connecter',
  'play.campaigns.signInToSee': 'pour voir les campagnes auxquelles vous avez adhéré.',
  'play.campaigns.fallbackNotice': 'Affichage des campagnes exemples — votre répertoire n\'a pas pu être chargé.',
  'play.campaigns.loading': 'Évocation de vos sagas…',
  'play.campaigns.empty': 'Vous n\'avez encore adhéré à aucune campagne.',
  'play.campaigns.assignedCharacter': 'Personnage Assigné',
  'play.campaigns.unassigned': 'Non Assigné',
  'play.campaigns.noCharactersYet': 'Aucun personnage pour le moment',
  'play.campaigns.enterCampaign': 'Accéder à la campagne',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'La Table',
  'play.vtt.launch': 'Lancer le VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — campagne {campaignId}',
  'play.vtt.veilHeadline': 'Le voile entre la table et le conte est ténu ici.',
  'play.vtt.prototypeIntro':
    'La table virtuelle temps réel arrive en phase ultérieure. Le prototype interactif s\'affichera dans ce cadre — appuyez sur',
  'play.vtt.prototypeOutro': 'pour préparer le conteneur.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Codex Recherche Rapide',
  'play.codex.searchPlaceholder': 'Cherchez un monstre, un sort, une règle…',
  'play.codex.searchAriaLabel': 'Rechercher dans l\'encyclopédie',
  'play.codex.searching': 'Divination…',
  'play.codex.noResults': 'Rien trouvé pour « {q} ».',
  'play.codex.hint': 'Tapez au moins deux caractères pour explorer l\'encyclopédie vivante sans quitter votre table.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Campagne',
  'play.campaign.fallbackDescription':
    'Les détails de la campagne n\'ont pas pu être chargés — vous pouvez toujours préparer votre personnage ci-dessous.',
  'play.campaign.seoTitle': 'Campagne',
  'play.campaign.noneSpecified': 'Aucune campagne spécifiée.',
  'play.campaign.seoTitleNamed': '{title} — Jouer',
  'play.campaign.seoTitleDefault': 'Campagne — Jouer',
  'play.campaign.backToLobby': 'Retour au hall',
  'play.campaign.gm': 'MJ {gm}',
  'play.campaign.playersCount': '{count} joueurs',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Sauvegardé dans votre codex.',
  'play.sheet.savedLocally': 'Sauvegardé localement (serveur indisponible).',
  'play.sheet.saveError': 'Impossible de sauvegarder votre personnage — le stockage est indisponible.',
  'play.sheet.loading': 'Déroulement de la feuille…',
  'play.sheet.heading': 'Feuille de Personnage',
  'play.sheet.avatarAlt': 'Avatar de {name}',
  'play.sheet.unclaimedHero': 'Héros sans maître',
  'play.sheet.abilityCheck': 'Test de {ability} ({formula}) :',
  'play.sheet.name': 'Nom',
  'play.sheet.namePlaceholder': 'Errant sans nom',
  'play.sheet.level': 'Niveau',
  'play.sheet.speciesLabel': 'Ascendance / Espèce',
  'play.sheet.loadingOption': 'Chargement…',
  'play.sheet.selectSpecies': 'Choisir une espèce',
  'play.sheet.classLabel': 'Classe',
  'play.sheet.selectClass': 'Choisir une classe',
  'play.sheet.abilityScores': 'Caractéristiques',
  'play.sheet.abilityScoresHint': '(cliquez sur le modificateur pour lancer les dés)',
  'play.sheet.abilityScoreAria': 'Caractéristique {ability}',
  'play.sheet.rollCheckAria': 'Lancer un test de {ability}',
  'play.sheet.hp': 'PV',
  'play.sheet.maxHp': 'PV Max',
  'play.sheet.ac': 'CA',
  'play.sheet.backstory': 'Histoire Personnelle',
  'play.sheet.backstoryPlaceholder': 'Quelle obscurité a mené cette âme à cette table ?',
  'play.sheet.canonCandidate': 'Candidat au Canon',
  'play.sheet.canonCandidateHint': 'Proposez ce personnage pour devenir partie du canon vivant de Grymwyrd.',
  'play.sheet.saving': 'Enregistrement…',
  'play.sheet.saveCharacter': 'Sauvegarder le Personnage',

  // CreateGameModal
  'play.create.errorNoName': 'Donnez un nom à votre table.',
  'play.create.errorNoSystem': 'Choisissez un système de jeu.',
  'play.create.you': 'Vous',
  'play.create.errorCreate': 'Le rituel a échoué — votre table n\'a pas pu être créée. Réessayez d\'ici peu.',
  'play.create.modalTitle': 'Convoquer une Table',
  'play.create.successCopy': 'Votre table est prête. Partagez ce lien d\'invitation pour convoquer vos joueurs.',
  'play.create.copyInviteAria': 'Copier le lien d\'invitation',
  'play.create.copied': 'Copié',
  'play.create.copy': 'Copier',
  'play.create.done': 'Terminé',
  'play.create.tableName': 'Nom de la Table',
  'play.create.tableNamePlaceholder': 'ex. Le Caveau du Deuil',
  'play.create.quickStart': 'Démarrage Rapide',
  'play.create.quickStartAria': 'Présets de démarrage rapide',
  'play.create.customPreset': 'Personnalisé',
  'play.create.customPresetDesc': 'Commencer de zéro',
  'play.create.gameSystem': 'Système de Jeu',
  'play.create.loadingSystems': 'Chargement des systèmes…',
  'play.create.systemFromPreset': '{system} (depuis un preset)',
  'play.create.systemDefault': 'Grymwyrd Cataclysm (défaut)',
  'play.create.tags': 'Tags',
  'play.create.tagsUpTo': '(jusqu\'à {count})',
  'play.create.removeTagAria': 'Retirer le tag {tag}',
  'play.create.tagLimitReached': 'Limite de tags atteinte',
  'play.create.tagPlaceholder': 'horreur, one-shot…',
  'play.create.maxPlayers': 'Nombre de Joueurs Max :',
  'play.create.cancel': 'Annuler',
  'play.create.convening': 'Convocation en cours…',
  'play.create.createTable': 'Créer la Table',

  // JoinPage
  'play.join.finding': 'Recherche de la table…',
  'play.join.expiredHeading': 'Cette invitation a expiré',
  'play.join.expiredBody': 'Les codes expirent pour des raisons de sécurité. Demandez un nouveau code à votre hôte.',
  'play.join.browseLiveTables': 'Parcourir les tables en direct',
  'play.join.errorHeading': 'Impossible de joindre la table',
  'play.join.errorBody': 'Une erreur s\'est produite lors de la recherche de votre invitation. Vérifiez votre connexion et réessayez.',
  'play.join.tryAgain': 'Réessayer',
  'play.join.defaultTableTitle': 'Une table Grymwyrd',
  'play.join.invited': 'Vous avez été convié à prendre place.',
  'play.join.signInToSeat': 'Connectez-vous pour prendre votre place',
  'play.join.createAccount': 'Nouveau venu ? Créez un compte gratuit',
  'play.join.opensAfterSignIn': 'La table s\'ouvre une fois que vous êtes connecté.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Jouer — Table Virtuelle',
  'play.lobby.seoDescription':
    'Trouvez une table, rejoignez une session en direct et forgez votre légende à la table virtuelle Grymwyrd.',
  'play.lobby.eyebrow': 'Table Virtuelle',
  'play.lobby.title': 'Jouer',
  'play.lobby.subtitle':
    'Réunissez votre covens. Jetez les os. Prenez place à une table où chaque choix résonne dans le canon vivant de Grymwyrd.',
  'play.lobby.createGame': 'Créer un Jeu',
  'play.lobby.playNow': 'Jouer Maintenant — sans compte requis',
  'play.lobby.signInToHost': 'Connectez-vous pour animer votre propre table',

  // SessionListLive
  'play.live.heading': 'En Direct Maintenant',
  'play.live.empty': 'Aucune table n\'est en direct à cette heure. Le voile est tranquille — lancez la vôtre.',
  'play.live.badge': 'Direct',
  'play.live.unknownSystem': 'Système inconnu',
  'play.live.gmSuffix': ' · MJ {gm}',
  'play.live.players': 'joueurs',

  // TableList — empty board
  'play.tables.emptyHeading': 'Aucune table ouverte pour le moment',
  'play.tables.emptyBody':
    'Le plateau est calme pour l\'instant. Soyez le premier à tirer une chaise — essayez la table invités instantanément, sans compte requis.',
  'play.tables.tryGuestTable': 'Essayer la table invités',
  'play.tables.orUse': 'Ou utilisez',
  'play.tables.createGame': 'Créer un Jeu',
  'play.tables.aboveToHost': 'ci-dessus pour animer la vôtre.',

  // TableList — waitlist
  'play.waitlist.joinError': 'Impossible de rejoindre la liste d\'attente — réessayez.',
  'play.waitlist.leaveError': 'Impossible de quitter la liste d\'attente — réessayez.',
  'play.waitlist.join': 'Rejoindre la liste d\'attente',
  'play.waitlist.leaving': 'Départ…',
  'play.waitlist.leave': 'Quitter la liste d\'attente',
  'play.waitlist.joining': 'Adhésion en cours…',

  // TableList — board
  'play.tables.heading': 'Tables Ouvertes',
  'play.tables.openSeatOnly': 'Sièges libres uniquement',
  'play.tables.systemFilterPlaceholder': 'Système…',
  'play.tables.systemFilterAria': 'Filtrer par système',
  'play.tables.tagsFilterPlaceholder': 'Tags (séparés par des virgules)…',
  'play.tables.tagsFilterAria': 'Filtrer par tags',
  'play.tables.fetchError': 'Impossible de joindre le plateau en direct — le hall est temporairement indisponible.',
  'play.tables.loading': 'Rassemblement des tables…',
  'play.tables.untitledTable': 'Table sans titre',
  'play.tables.full': 'Complet',
  'play.tables.seatedCount': '{count} assis',
  'play.tables.viewTable': 'Voir la Table',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'Chat de la Table',
  'chat.empty': 'Aucun message pour le moment. Dites quelque chose à la table.',
  'chat.inputPlaceholder': 'Envoyer un message à la table…',
  'chat.inputAria': 'Message de chat',
  'chat.send': 'Envoyer',
  'chat.translatedFrom': 'Traduit de {lang}',
  'chat.original': 'Original',
  'chat.showOriginal': 'Afficher l\'original',
  'chat.showTranslation': 'Afficher la traduction',
  'chat.showOriginalsAll': 'Afficher les originaux',
  'chat.showTranslationsAll': 'Afficher les traductions',
}
